import { jsxs as m, jsx as e, Fragment as v } from "react/jsx-runtime";
import { withManagedProps as b } from "@made-people/managed-props";
import { z as s } from "zod";
import { withZod as C } from "@made-people/react-prop-guard";
import { voucherInputBlueprint as j, voucherListBlueprint as P, cartTotalsStyling as D, cartItemsStyling as I, cartSummaryBirchStyling as A } from "./index-blueprint.es.js";
import { AnimatePresence as V, motion as k } from "motion/react";
import { useCartMethod as x, useCartState as g, lineItemSchema as F } from "@made-people/grease-cart";
import { useTranslate as S } from "@made-people/grease-translations";
import { inputFieldSchema as L, InputField as z } from "@made-people/blueprint-form";
import { buttonAsButtonSchema as R, Button as W } from "@made-people/blueprint-button";
import { useState as f } from "react";
import { toast as N } from "@made-people/blueprint-toast";
import { linkAsButtonSchema as q, LinkAsButton as H } from "@made-people/blueprint-link";
import { CartItem as M } from "@made-people/blueprint-cart-item";
import { headingSchema as G, Heading as O } from "@made-people/blueprint-heading";
import "@made-people/blueprint";
const B = s.object({
  inputField: L.optional(),
  applyButton: R.optional(),
  triggerLink: q.optional(),
  enabled: s.boolean().optional()
}), Q = b(
  "VoucherInput",
  C(
    {
      schema: B,
      defaultProps: {
        enabled: !0,
        inputField: {
          template: "simple",
          variants: {
            size: "sm"
          }
        }
      }
    },
    ({ inputField: a, applyButton: n, triggerLink: i, enabled: c }) => {
      const { execute: o, loadingState: t } = x("addVoucher");
      if (!c)
        return !0;
      const r = S(), [p, l] = f(!1), [_, y] = f(""), h = j.styles(), u = async () => {
        try {
          await o({ voucherCode: _ }), y(""), N({
            type: "success",
            title: r("Checkout_Voucher_Added_Success")
          }), l(!1);
        } catch {
          N({
            type: "error",
            title: r("Checkout_Voucher_Added_Error")
          });
        }
      };
      return /* @__PURE__ */ m(
        "div",
        {
          className: h.base,
          "data-is-active": p ? "true" : "false",
          children: [
            /* @__PURE__ */ e(
              H,
              {
                className: h.trigger,
                onClick: () => l(!p),
                label: r("Checkout_Voucher_Button_Text"),
                ...i
              }
            ),
            /* @__PURE__ */ e(V, { children: p && /* @__PURE__ */ m(
              k.form,
              {
                initial: { opacity: 0 },
                animate: { opacity: 1 },
                exit: { opacity: 0 },
                className: h.inputWrapper,
                onSubmit: (d) => {
                  d.preventDefault(), u();
                },
                children: [
                  /* @__PURE__ */ e(
                    z,
                    {
                      onChange: (d) => y(d.target.value),
                      value: _,
                      ...a
                    }
                  ),
                  /* @__PURE__ */ e(
                    W,
                    {
                      as: "button",
                      progress: t,
                      label: r("Checkout_Voucher_Apply"),
                      ...n
                    }
                  )
                ]
              }
            ) })
          ]
        }
      );
    }
  )
), Y = ({
  voucher: a,
  slots: n,
  isRemoveable: i
}) => {
  const { execute: c, loadingState: o } = x("removeVoucher"), t = S(), r = async () => {
    if (!a.code)
      return null;
    try {
      await c({ voucherCode: a.code }), N({
        type: "success",
        title: t("Checkout_Voucher_Remove_Success")
      });
    } catch (p) {
      N({
        type: "error",
        title: t("Checkout_Voucher_Remove_Error")
      }), console.error(p);
    }
  };
  return /* @__PURE__ */ m("div", { className: n.item, "data-state": o, children: [
    /* @__PURE__ */ e("span", { className: n.name, children: a.code || a.name && t("Checkout_Discount_Code", {
      code: /* @__PURE__ */ e("span", { className: n.code, children: a.name || a.code })
    }) }),
    i && a.code && /* @__PURE__ */ e("button", { className: n.deleteButton, onClick: r, children: t("Checkout_Discount_Delete", { code: a == null ? void 0 : a.code }) }),
    (a == null ? void 0 : a.discount) && (a == null ? void 0 : a.discount.number) !== 0 && /* @__PURE__ */ e("span", { className: n.discount, children: a.discount.formatted })
  ] });
}, Z = b("VoucherList", () => {
  var i, c;
  const a = g(), n = P.styles();
  return (c = (i = a.cart) == null ? void 0 : i.vouchers) != null && c.length ? /* @__PURE__ */ e("div", { className: n.base, children: a.cart.vouchers.map((o, t) => /* @__PURE__ */ e(
    Y,
    {
      slots: n,
      voucher: o,
      isRemoveable: o.type === "code"
    },
    t
  )) }) : null;
}), J = s.object({
  label: s.string().optional(),
  value: s.union([s.string(), s.custom()]).optional()
}), w = s.object({
  variants: s.custom().optional(),
  hide: s.boolean().optional(),
  customRows: s.array(J).optional(),
  voucher: B.optional(),
  fieldsEnabled: s.object({
    subtotal: s.boolean().optional(),
    discount: s.boolean().optional(),
    tax: s.boolean().optional(),
    shipping: s.boolean().optional(),
    grandTotal: s.boolean().optional()
  }).optional()
}), K = C(
  {
    schema: w,
    defaultProps: {
      hide: !1,
      voucher: {
        enabled: !0
      },
      fieldsEnabled: {
        subtotal: !0,
        discount: !0,
        tax: !0,
        shipping: !0,
        grandTotal: !0
      }
    }
  },
  ({ variants: a, customRows: n, hide: i, voucher: c, fieldsEnabled: o }) => {
    var y, h;
    const t = D.styles(a), r = S(), { cart: p } = g();
    if (!(p != null && p.totals) || (i ?? !1))
      return null;
    const l = p.totals, _ = (u) => typeof u == "function" ? u(l) : r(u);
    return /* @__PURE__ */ m(v, { children: [
      (c == null ? void 0 : c.enabled) && /* @__PURE__ */ e(Q, { ...c }),
      /* @__PURE__ */ m(k.div, { className: t.wrapper, children: [
        n == null ? void 0 : n.map((u, d) => /* @__PURE__ */ m("div", { className: t.row, children: [
          u.label && /* @__PURE__ */ e("span", { className: t.label, children: r(u.label) }),
          u.value && /* @__PURE__ */ e("span", { className: t.value, children: _(u.value) })
        ] }, d)),
        ((y = l.subtotal) == null ? void 0 : y.formatted) && (o == null ? void 0 : o.subtotal) && /* @__PURE__ */ m("div", { className: t.row, children: [
          /* @__PURE__ */ e("span", { className: t.label, children: r("Checkout_CartTotals_Subtotal") }),
          /* @__PURE__ */ e("span", { className: t.value, children: l.subtotal.formatted })
        ] }),
        (c == null ? void 0 : c.enabled) && /* @__PURE__ */ e(Z, {}),
        l.discount && (o == null ? void 0 : o.discount) && /* @__PURE__ */ m("div", { className: t.row, "data-is-discounted": "true", children: [
          /* @__PURE__ */ e("span", { className: t.label, children: r("Checkout_CartTotals_Discount") }),
          /* @__PURE__ */ e("span", { className: t.value, children: l.discount.formatted })
        ] }),
        ((h = l.tax) == null ? void 0 : h.formatted) && l.tax.number !== 0 && (o == null ? void 0 : o.tax) && /* @__PURE__ */ m("div", { className: t.row, children: [
          /* @__PURE__ */ e("span", { className: t.label, children: r("Checkout_CartTotals_Tax") }),
          /* @__PURE__ */ e("span", { className: t.value, children: l.tax.formatted })
        ] }),
        l.shipping && (o == null ? void 0 : o.shipping) && /* @__PURE__ */ m("div", { className: t.row, children: [
          /* @__PURE__ */ e("span", { className: t.label, children: r("Checkout_CartTotals_Shipping") }),
          /* @__PURE__ */ e("span", { className: t.value, children: l.shipping.number === 0 ? r("Checkout_CartTotals_FreeShipping") : l.shipping.formatted })
        ] }),
        l.grandTotal && (o == null ? void 0 : o.grandTotal) && /* @__PURE__ */ m("div", { className: t.row, children: [
          /* @__PURE__ */ e("span", { className: t.label, children: r("Checkout_CartTotals_Grandtotal") }),
          /* @__PURE__ */ e("span", { className: t.value, children: l.grandTotal.formatted })
        ] })
      ] }, "cart-totals")
    ] });
  }
), U = s.object({
  variants: s.custom().optional(),
  /**
   * Settings for the cart items, if you want to override the default settings.
   */
  itemSettings: s.custom().optional(),
  items: s.array(F).optional()
}), X = ({
  variants: a,
  itemSettings: n,
  items: i
}) => {
  const c = I.styles(a), { cart: o } = g(), t = i ?? (o == null ? void 0 : o.items);
  return /* @__PURE__ */ e(k.section, { layout: !0, id: "cart-items", className: c.wrapper, children: /* @__PURE__ */ e(V, { mode: "popLayout", initial: !1, children: t == null ? void 0 : t.map((r) => /* @__PURE__ */ e(M, { data: r, ...n }, r.lineId)) }) });
}, T = s.object({
  template: s.literal("birch"),
  variants: s.custom().optional(),
  cartTotalsSettings: w.optional(),
  headingSettings: G.optional(),
  cartDisplay: s.enum(["total_items", "total_quantity"]).optional(),
  cartItemsSettings: U.optional()
}), $ = C(
  T,
  ({
    variants: a,
    cartTotalsSettings: n,
    headingSettings: i,
    cartDisplay: c,
    cartItemsSettings: o
  }) => {
    var h;
    const t = A.styles(a), { cart: r } = g(), p = S(), l = ((h = o == null ? void 0 : o.items) == null ? void 0 : h.length) ?? (c === "total_items" ? r == null ? void 0 : r.items.length : r == null ? void 0 : r.items.reduce((u, d) => u + d.quantity, 0)), _ = (i == null ? void 0 : i.variants) ?? {
      headingSize: "xs"
    }, y = o ?? {
      itemSettings: {
        templateProps: {
          template: "tokyo"
        }
      }
    };
    return /* @__PURE__ */ m("div", { className: t.wrapper, children: [
      /* @__PURE__ */ m("div", { className: t.cartWrapper, children: [
        /* @__PURE__ */ e(
          O,
          {
            className: t.header,
            heading: p("Checkout_Your_Cart", {
              amountOfItems: l ?? 0
            }),
            ...i,
            variants: _
          }
        ),
        /* @__PURE__ */ e(X, { ...y })
      ] }),
      /* @__PURE__ */ e(
        K,
        {
          variants: {
            withBackground: "true"
          },
          ...n
        }
      )
    ] });
  }
), E = T, tt = C(
  T,
  (a) => {
    switch (a.template) {
      case "birch":
        return /* @__PURE__ */ e($, { ...a });
      default:
        return null;
    }
  }
), at = "birch", et = s.object({
  templateProps: E.optional()
}), gt = b(
  "CartSummary",
  C(et, (a) => {
    const n = a.templateProps || { template: at };
    return /* @__PURE__ */ e(tt, { ...n });
  })
);
export {
  X as CartItems,
  gt as CartSummary,
  K as CartTotals,
  tt as SelectTemplate,
  $ as TemplateBirch,
  Q as VoucherInput,
  Z as VoucherList,
  Y as VoucherRow,
  U as cartItemsSchema,
  et as cartSummaryPropsSchema,
  E as cartSummarySchema,
  T as cartSummaryTemplateBirchSchema,
  w as cartTotalsSchema,
  B as voucherInputSchema
};
//# sourceMappingURL=index.es.js.map
